/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import config from 'src/config';

export const bootstrapperAPI = (settings) =>
  axios.create({
    baseURL: config.api.endpoint,
    headers: { Authorization: `Bearer ${settings?.token}` }
  });

export const logServiceAPI = () =>
  axios.create({
    baseURL: config.logService.endpoint
    // headers: { 'x-api-key': config.logService.apiKey }
  });

export const uploadServiceAPI = (settings) => {
  const { endpoint, token } = settings || {};
  return axios.create({
    baseURL: endpoint,
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const downloadServiceAPI = (settings) =>
  axios.create({
    baseURL: config.downloadService.package.endpoint,
    headers: { Authorization: `Bearer ${settings?.token}` }
  });
